/**
 * Allows NodeJS callback style functions to be called as if they were async. In other words, rather than calling
 * `someAsyncFunction(args, function (error, result) { // test error or do work and return result }`, you can call
 * `await asAsync(someAsyncFunction, args)` instead
 * @param fn Node style function to call
 * @param args
 * @returns {Promise}
 */
export const asAsync = (fn, ...args) => {
  return new Promise((resolve, reject) => {
    fn(...args, (e, r) => e ? reject(e) : resolve(r));
  });
};

/**
 * Pauses execution for however long you want.
 * @param howLong
 * @returns {Promise<any>}
 */
export const wait = (howLong) => {
  return new Promise(resolve => {
    setTimeout(resolve, howLong);
  });
};



// WEBPACK FOOTER //
// ./src/shared/util/async.js